/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import Header from 'parts/Header';
import Footer from 'parts/Footer';

import {
  JobOpenings,
  HiringProcess,
  CareerPathways,
  EarlyCareers as EarlyCareersData,
  LifeAtW7L,
  Perks,
  JoinUsFAQ,
} from 'json/landingPageData';

import ParticleBackground from '../elements/ParticleBackground';

const PerkIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

export class CareersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleJobs: 6,
      query: '',
      location: '',
      openFaq: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  toggleFaq = (idx) => {
    this.setState((prev) => ({ openFaq: prev.openFaq === idx ? null : idx }));
  };

  loadMore = () => {
    this.setState((prev) => ({ visibleJobs: prev.visibleJobs + 4 }));
  };

  filteredJobs = () => {
    const { query, location } = this.state;
    return JobOpenings.filter((job) => {
      const q = query.trim().toLowerCase();
      const l = location.trim().toLowerCase();
      const matchQ = !q
        || job.title.toLowerCase().includes(q)
        || job.tags.some((t) => t.toLowerCase().includes(q));
      const matchL = !l || job.location.toLowerCase().includes(l);
      return matchQ && matchL;
    });
  };

  render() {
    const {
      visibleJobs, query, location, openFaq,
    } = this.state;
    const matched = this.filteredJobs();
    const shown = matched.slice(0, visibleJobs);

    return (
      <div className="neon-theme min-h-screen">
        <Header />
        <ParticleBackground />

        {/* Hero */}
        <section className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="services-hero">
            <span className="hiring-badge">We&apos;re hiring</span>
            <h1 className="mt-6">
              Career Opportunities <br />
              <span className="neon-text">for Growth</span>
            </h1>
            <p className="mt-4">
              Join our expanding team of engineers, marketers, and builders working on real
              software products. Grow your career while helping businesses achieve unprecedented
              growth through technology.
            </p>
          </div>
        </section>

        {/* Search */}
        <section id="open-positions" className="container mx-auto px-4 lg:px-8 pb-6 relative z-10">
          <div className="career-search">
            <div>
              <label htmlFor="job-query">Search Positions</label>
              <input
                id="job-query"
                type="text"
                placeholder="Search role (e.g. Python, Frontend)"
                value={query}
                onChange={(e) => this.setState({ query: e.target.value, visibleJobs: 6 })}
              />
            </div>
            <div>
              <label htmlFor="job-loc">Location</label>
              <input
                id="job-loc"
                type="text"
                placeholder="City or Remote"
                value={location}
                onChange={(e) => this.setState({ location: e.target.value, visibleJobs: 6 })}
              />
            </div>
          </div>
        </section>

        {/* Job listings */}
        <section className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="job-results-count">
              {Math.min(visibleJobs, matched.length)} of {matched.length} results
            </div>

            {shown.length === 0 && (
              <div className="text-center text-gray-400 py-8">
                No matching openings. Try a different search.
              </div>
            )}

            {shown.map((job) => (
              <div key={job.id} className="job-row">
                <div>
                  <div className="job-row-header">
                    <span className="job-row-title">{job.title}</span>
                    <span className="job-pill">
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 2a6 6 0 00-6 6c0 4.5 6 10 6 10s6-5.5 6-10a6 6 0 00-6-6zm0 8a2 2 0 110-4 2 2 0 010 4z" />
                      </svg>
                      {job.location}
                    </span>
                    <span className="job-pill is-openings">
                      {job.openings} {job.openings === 1 ? 'opening' : 'openings'}
                    </span>
                  </div>
                  <p className="job-row-desc">{job.description}</p>
                  <div className="job-tag-row">
                    {job.tags.map((tag) => (
                      <span key={tag} className="job-tag">{tag}</span>
                    ))}
                  </div>
                </div>
                <a href={`/careers/${job.id}`} className="job-row-action">
                  View Details
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </a>
              </div>
            ))}

            {visibleJobs < matched.length && (
              <div className="text-center mt-6">
                <button type="button" className="load-more-btn" onClick={this.loadMore}>
                  Load More Opportunities
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </section>

        {/* Hiring Process */}
        <section id="hiring-process" className="container mx-auto px-4 lg:px-8 py-20 relative z-10">
          <div className="text-center mb-12">
            <span className="section-eyebrow">Process</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4">
              Our Hiring <span className="neon-text">Process</span>
            </h2>
            <p className="text-blue-100 text-base max-w-2xl mx-auto mt-4">
              Transparent, friendly, and fast. We respect your time and focus on real signals.
            </p>
          </div>
          <div className="max-w-6xl mx-auto">
            <div className="hiring-steps">
              {HiringProcess.map((s) => (
                <div key={s.title} className="hiring-step">
                  <span className="hiring-step-num">{s.step}</span>
                  <div className="hiring-step-title">{s.title}</div>
                  <p className="hiring-step-desc">{s.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Career Pathways */}
        <section id="career-pathways" className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="text-center mb-12">
            <span className="section-eyebrow">Pathways</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4">
              Career <span className="neon-text">Pathways</span>
            </h2>
            <p className="text-blue-100 text-base max-w-2xl mx-auto mt-4">
              Clear growth at every level. We align scope, ownership, and learning with your goals.
            </p>
          </div>
          <div className="max-w-6xl mx-auto pathway-grid">
            {CareerPathways.map((p) => (
              <div key={p.title} className="pathway-card">
                <h4>{p.title}</h4>
                <p>{p.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Early Careers */}
        <section id="early-careers" className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="early-careers-grid">
              <div>
                <span className="section-eyebrow">Early Careers</span>
                <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4 mb-4">
                  {EarlyCareersData.heading}
                </h2>
                <p className="text-blue-100 text-base leading-relaxed">{EarlyCareersData.body}</p>
                <div className="early-careers-tags">
                  {EarlyCareersData.tags.map((t, i) => (
                    <span
                      key={t}
                      className={`early-careers-tag ${i === 2 ? 'is-mentor' : ''}`}
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <ul className="early-careers-bullets">
                  {EarlyCareersData.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
                <div className="flex gap-3 flex-wrap mt-4">
                  <a href="/contact" className="hero-cta-primary">
                    Talk to us
                  </a>
                  <a href="/contact" className="hero-cta-secondary">
                    Apply now
                  </a>
                </div>
              </div>
              <div>
                <div className="contact-info-card">
                  {EarlyCareersData.details.map((d) => (
                    <div key={d.title} className="early-careers-detail">
                      <h4>{d.title}</h4>
                      <p>{d.body}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Life at Web7Labs */}
        <section id="life-at-w7l" className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="text-center mb-12">
            <span className="section-eyebrow">Culture</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4">
              Life at <span className="neon-text">Web7Labs</span>
            </h2>
            <p className="text-blue-100 text-base max-w-2xl mx-auto mt-4">
              We&apos;re a growth-oriented engineering company. Expect autonomy, mentorship, and
              a clear path to bigger challenges — designed to accelerate your career.
            </p>
          </div>
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
            {LifeAtW7L.map((v) => (
              <div key={v.title} className="ai-card">
                <h4>{v.title}</h4>
                <p>{v.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Perks & Benefits */}
        <section id="perks-benefits" className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="text-center mb-12">
            <span className="section-eyebrow">Benefits</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4">
              Perks &amp; <span className="neon-text">Benefits</span>
            </h2>
            <p className="text-blue-100 text-base max-w-2xl mx-auto mt-4">
              Thoughtfully designed to support growth, balance, and real impact.
            </p>
          </div>
          <div className="max-w-6xl mx-auto perks-grid">
            {Perks.map((p) => (
              <div key={p.title} className="perk-card">
                <div className="perk-icon"><PerkIcon /></div>
                <div>
                  <h4>{p.title}</h4>
                  <p>{p.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section id="join-faq" className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="text-center mb-10">
            <span className="section-eyebrow">FAQ</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4">
              Frequently <span className="neon-text">asked</span>
            </h2>
          </div>
          <div className="faq-list">
            {JoinUsFAQ.map((item, idx) => (
              <div key={item.q} className={`faq-item ${openFaq === idx ? 'is-open' : ''}`}>
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => this.toggleFaq(idx)}
                >
                  {item.q}
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {openFaq === idx && (
                  <div className="faq-answer">{item.a}</div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Closing CTA */}
        <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="max-w-4xl mx-auto careers-cta-banner">
            <h2>Ready to build with us?</h2>
            <p>
              If you don&apos;t see a role that fits, reach out anyway — great people create
              their own roles.
            </p>
            <div className="careers-cta-buttons">
              <a href="/contact" className="hero-cta-primary">
                Contact Us
              </a>
              <a href="/contact" className="hero-cta-secondary">
                Apply Now
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default CareersPage;
